import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { PurchaseDetails } from '@/components/Billing/billing-types';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
// @ts-ignore
import UpgradeMultiplePlansPayment from '@/components/dialogs/UpgradeMultiplePlansDialog/UpgradeMultiplePlansPayment.vue';
// @ts-ignore
import UpgradeMultiplePlansReview from '@/components/dialogs/UpgradeMultiplePlansDialog/UpgradeMultiplePlansReview.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeMultiplePlansDialog',
  props: {
    planEndDate: null,
    totalDueToday: null,
    renewableAmount: null,
    newPurchaseDetails: null,
    currentPurchaseDetails: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	planEndDate: string;
	totalDueToday: string;
	renewableAmount: string;
	newPurchaseDetails: PurchaseDetails;
	currentPurchaseDetails: PurchaseDetails;
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}



const isLoadingPurchase = ref(false);
const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, isLoadingPurchase, close, AppDialog, UpgradeMultiplePlansPayment, UpgradeMultiplePlansReview }
}

})